const markAsMissingKey = str => "!" + str + "!";
export const createTranslationFn = function (translations, context) {
  if (context === void 0) {
    context = {};
  }
  return key => {
    const translation = translations[key];
    if (!translation) {
      return markAsMissingKey(key);
    }
    return translation.replace(
    // matches `var` in "<%=var%>"
    /<%=([^%]+)%>/g, (_, variable) => {
      var _context$variable;
      return (_context$variable = context[variable]) != null ? _context$variable : markAsMissingKey(variable);
    });
  };
};
//# sourceMappingURL=translate.js.map